import React, { useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { FlexContainer, PureSpinner } from 'heliocor-ui'

import { 
    REQUEST_SEND_DOC_TO_SERVICE, 
    REQUEST_DELETE_STORED_DOCUMENT, 
    REQUEST_DELETE_FILE_FROM_DOC,
    REQUEST_STORE_DOCUMENT,
    REQUEST_UPLOAD_ENTITY_DOC,
    REQUEST_SEND_DOC_FOR_MANUAL_VALIDATION
} from '../store/cafe/actionTypes'


import CommonTitle from '../common/CommonTitle'
import { DocumentsSection } from '../components/documents/DocumentsSection'
import { getUploadedDocumentsData } from '../utils/documents'


const Documents = ({category={}, errorHandler}) => {

    const { t } = useTranslation()
    const partyType = useSelector(store => store.config.partyType)
    const documentsUploaded = useSelector(store => store.party.documents)
    const isRequest = useSelector(store => store.config.isRequest)

    const documentsData = getUploadedDocumentsData(category, documentsUploaded) 
    const { localeKey, numberOfDocsToUpload } = documentsData

    const dispatch = useDispatch()

    const validateDocument = useCallback((image, document, kind, extraImage) => {
        dispatch({
            type: REQUEST_SEND_DOC_TO_SERVICE,
            image,
            extraImage,
            document,
            partyType,
            kind
        })
    }, [partyType, dispatch])

    const storeDocument = useCallback((image, document, fileName) => 
        dispatch({ type: REQUEST_STORE_DOCUMENT, image, document, kind: category.code, fileName }
    ),[category, dispatch])

    const deleteDocument = useCallback((docType) => {
        dispatch({type: REQUEST_DELETE_STORED_DOCUMENT, docType})
    }, [dispatch])

    const deleteIndividualDocument = useCallback((document) => {
        dispatch({type: REQUEST_DELETE_FILE_FROM_DOC, document})
    }, [dispatch])

    const uploadRequestDocuments = useCallback(
        (kind, document, image, fileName) => dispatch({ type: REQUEST_UPLOAD_ENTITY_DOC, kind, document, image, fileName }),
        [dispatch]
    )

    const sendForManualValidation = useCallback(
        (docType) => dispatch({type: REQUEST_SEND_DOC_FOR_MANUAL_VALIDATION, docType}),
        [dispatch]
    )

    const handleUpload = ({image, extraImage, fileName, isCore, selected}) => {
        if (((isCore && ['PROOF_IDENTITY', 'PROOF_ADDRESS', 'PHOTO'].includes(category.code)) || category.code === 'PROOF_ADDRESS')) {
            return validateDocument(image, selected, category.code, extraImage)
        } else {
            if(isRequest){
                uploadRequestDocuments(category.code, selected, image, fileName)
            } else {
                storeDocument(image, selected, fileName)
            }
        }
    }

    useEffect(() => {
        if(numberOfDocsToUpload > 0){
            errorHandler({minDocs: 'need to upload more docs'})
        }else{
            errorHandler({minDocs: []}) 
        }

        return () => {
            errorHandler({minDocs: []})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [numberOfDocsToUpload])
    
    return (
        !category?.documents ? <PureSpinner /> :
        <FlexContainer width='100%' column>
            <CommonTitle 
                translate='' 
                margin='-20px 0 -10px'
                description={numberOfDocsToUpload > 0 && t(localeKey, {min: numberOfDocsToUpload})}
            />
            <FlexContainer column>
                <DocumentsSection 
                    documents={category.documents}
                    handleUpload={handleUpload} 
                    deleteDocument={deleteDocument}
                    deleteIndividualDocument={deleteIndividualDocument}
                    documentsUploaded={documentsUploaded}
                    sendForManualValidation={sendForManualValidation}
                />
            </FlexContainer>
        </FlexContainer>
    )
}

export { Documents }
